export const HEIGHT = process.env.RAZZLE_MAP_HEIGHT || {mobile: '100vh', desktop: '90vh'}
export const DEFAULT_ZOOM = process.env.RAZZLE_MAP_DEFAULT_ZOOM || 1
export const DEFAULT_CENTER = process.env.RAZZLE_MAP_DEFAULT_CENTER || {lat: 25.43945821904415, lng: -40.0516999499999713}


export const GOOGLE_MAP_LANGUAGE = process.env.RAZZLE_GOOGLE_MAP_LANGUAGE || 'fr'
export const AVAILABILITY_FILTER_ACTIVE = process.env.RAZZLE_AVAILABILITY_FILTER_ACTIVE || false

export const BASE_API_URL = process.env.RAZZLE_BASE_API_URL
export const BASE_URL = process.env.RAZZLE_BASE_URL
export const GOOGLE_MAP_API_KEY = process.env.RAZZLE_GOOGLE_MAP_API_KEY
